export default __webpack_public_path__ + "static/media/tw.a72a99cb.svg";